export const SLIDE_STEP = 1;
